import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronLeft } from 'lucide-react';
import '../styles/product-list.css';
import { getProducts, getImageUrl } from '../lib/api';

const ProductList = ({ category, onProductClick, onBack }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    
    const fetchProducts = async () => {
      try {
        if (category?._id) {
          const productsData = await getProducts(category._id);
          setProducts(productsData);
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Error fetching products:', error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category]);

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="product-list-page">
      <Helmet>
        <title>{category?.name || 'Products'} - Sitcorp International</title>
        <meta name="description" content={`Browse our collection of ${category?.name} products. Quality manufacturing and sustainable sourcing by Sitcorp International.`} />
        <link rel="canonical" href={`https://sitcorpinternational.com/products/${category?._id}`} />
      </Helmet>

      <div className="container">
        <div className="product-list-header">
          <div className="header-content">
            <h1>{category?.name || 'Products'}</h1>
            <p>{products.length} {products.length === 1 ? 'product' : 'products'} available</p>
          </div>
        </div>

        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading products...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="empty-state">
            <p>No products in this category yet</p>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <div 
                key={product._id} 
                className="product-card"
                onClick={() => onProductClick({ ...product, category: category?.name })}
              >
                <div className="product-image">
                  <img
                    src={getImageUrl(product.image, product.uploadedAt ? new Date(product.uploadedAt).getTime() : null)}
                    alt={product.name}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="image-overlay">
                    <span>View Details</span>
                  </div>
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductList;
